<template lang="pug">
    v-autocomplete(dense 
        v-model="dataStatus" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        item-text="description" 
        item-value="id" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectUploadStatus",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
        "allOption"
    ],
    data() {
        return {
            dataStatus: {},
            listData: []
        }
    },
    mounted() {
        this.doLoad();
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        }
    },
    methods: {
        doInit(values){
            this.dataStatus = values ? values : null;
        },
        doLoad(){
            this.$http.get("/api/parameter/upload-status").then(success => {
                this.listData = success.data;
                if(this.allOption === true){
                    this.listData.unshift({"id": "ALL", "description": "-- SEMUA --"});
                }
                this.dataStatus = this.listData ? this.listData[0].id : null;
                this.onSelect();
            });
        },
        onSelect() {
            this.$emit("input", this.dataStatus);
            this.$emit("select", this.dataStatus);
            this.$emit("status", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataStatus === element.id) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>